module.exports = __webpack_public_path__ + "img/logo_escrita.adc58fb3.png";